import { isObject, isString, merge } from 'lodash';
import { parse, stringify } from 'qs';

import { PartialQuery, Query } from '@shared/api/types';

export const DEFAULT_PAGE_SIZE = 10;

export function toQueryString(query: PartialQuery, defaults?: PartialQuery): string {
  const queryStringQuery: Record<string, any> = JSON.parse(JSON.stringify(query));

  const defaultQuery = withDefaults(defaults || {});

  if (!queryStringQuery.sort || queryStringQuery.sort === defaultQuery.sort) {
    delete queryStringQuery.sort;
  }

  if (!queryStringQuery.filter) {
    delete queryStringQuery.filter;
  } else {
    for (let key in queryStringQuery.filter) {
      if (queryStringQuery.filter[key] === '' || queryStringQuery.filter[key] === null) {
        delete queryStringQuery.filter[key];
      }

      if (defaultQuery.filter[key] !== undefined && defaultQuery.filter[key] === queryStringQuery.filter[key]) {
        delete queryStringQuery.filter[key];
      }
    }
  }

  if (queryStringQuery.include) {
    queryStringQuery.include = queryStringQuery.include.join(',');
  }

  if (queryStringQuery.page?.number && queryStringQuery.page.number === defaultQuery.page.number) {
    delete queryStringQuery.page.number;
  }

  if (queryStringQuery.page?.size && queryStringQuery.page.size === defaultQuery.page.size) {
    delete queryStringQuery.page.size;
  }

  return stringify(queryStringQuery);
}

export function fromQueryString(queryString: string, defaults?: PartialQuery): Query {
  const parsed = parse(queryString);

  const parsedPage = isObject(parsed.page) ? (parsed.page as { number?: string; size?: string }) : {};

  return withDefaults({
    sort: isString(parsed.sort) ? parsed.sort : defaults?.sort || undefined,
    filter:
      isObject(parsed.filter) || isObject(defaults?.filter) ? merge({}, parsed.filter, defaults?.filter) : undefined,
    include: isString(parsed.include) ? parsed.include.split(',') : defaults?.include || undefined,
    page: {
      number: isString(parsedPage.number) ? parseInt(parsedPage.number) : defaults?.page?.number || undefined,
      size: isString(parsedPage.size) ? parseInt(parsedPage.size) : defaults?.page?.size || undefined,
    },
  });
}

export function withDefaults(query: PartialQuery): Query {
  return {
    sort: query.sort || '',
    filter: query.filter || {},
    include: query.include || [],
    page: {
      number: query.page?.number || 1,
      size: query.page?.size || DEFAULT_PAGE_SIZE,
    },
  };
}
